module.exports = __webpack_public_path__ + "img/1 (8).0580a0b4.png";